import Vue from 'vue' // 引入vue
import Vuex from 'vuex' // 引入vuex

// 使用vuex
Vue.use(Vuex)

// 创建vuex实例
const store = new Vuex.Store({
  state: {
    activeIndex: '/',
    todayViewCount: 0,
    monthViewCount: 0,
  },
  mutations: {
    changeNavs (state,activeIndex) {
      console.log(state,activeIndex)
      state.activeIndex = activeIndex
    },
    updateViewCount(state, data) {
      state.todayViewCount = data.todayNum;
      state.monthViewCount = data.monthNum;
    }
  },
})

export default store // 导出store
